import accountGroupsTemplate from './accountsGroupTable.html';
import { TableGroupController } from '../tableGroupController';
import { TAB_COUNTRY, TAB_CURRENCY, TAB_BANK } from '../../../views/accounts/overview';
import { AccountService } from '../../../services/AccountService';
import { accounts } from '../../../services/arsweb/RoutingPaths';
import { ACCOUNTS_TITLE } from '../../../services/arsweb/TableTitles';
import { EXPORT_TYPE } from '../../export/ExportModalController';
import { reactAccountCols } from "./accountColDefs";
import { CONSOLIDATION_CURRENCY_PARAMS } from "../../../controller/CommonViewController";

const DEF_GROUPS = [{ key: 'NONE', code: '' }, { key: 'CURRENCY', code: TAB_CURRENCY }, { key: 'BANK', code: TAB_BANK }, { key: 'COUNTRY', code: TAB_COUNTRY }];

/** @ngInject */
export function accountsGroupTable() {
    return {
        restrict: 'E',
        scope: {
            tableId: '=',
            consolitationcurrency: '=',
            mainCurrencies: '=',
            mainCurrenciesPromise: '=',
            groupData: '=',
            parentController: '='
        },
        templateUrl: accountGroupsTemplate,
        controller: AccountsGroupTableController,
        controllerAs: 'accountsGroupTableController'
    };
}

/** @ngInject */
export class AccountsGroupTableController extends TableGroupController {

    constructor($scope, userService, arsMainDependencies, $anchorScroll)  {

        super($scope, userService, arsMainDependencies, new AccountService(userService), 'accountsGroupTableParams',
            reactAccountCols(userService.fsMainDependencies.$translate, userService,[$scope.parentController.tabNameId]),
            accounts, ACCOUNTS_TITLE, 'accountTableParams' + $scope.parentController.tabNameId);

        this.promise = null;

        // extract anchor variable, params are reset
        const anchorName = arsMainDependencies.$stateParams.anchorName;
        this.$anchorScroll = $anchorScroll;
        this.$location = userService.fsMainDependencies.$location;
        this.groups = $scope.groupData;
        this.loadGroupData(this.$scope.parentController.tabNameId);

        this.supportedExports = [EXPORT_TYPE.CSV, EXPORT_TYPE.XLSX, EXPORT_TYPE.PDF_ACCOUNT_OVERVIEW];

        // ensure page is loaded
        angular.element(document).ready(() => {
            // expand the selected element
            if( anchorName) {
                this.expandGroupData(anchorName);
            }
        });

        $scope.$on('expandGroupData', (e, data) => this.expandGroupData(data)); // Listen to jVectorMap clicks

        // Listen to consolidation currency selection change
        $scope.$on('groupData.change', (a, args) => {
            this.groups = args;
            this.loadGroupData(this.$scope.parentController.tabNameId);
        });

    }

    expandGroupData(data) {
        // startsWith as bank name in pie are short name e.g. "Jpmorgan Chas" instead of "Jpmorgan Chase Bank, N.A."
        const isHiddenStrict = group => group.code !== data.name && !(data.code && group.code === data.code);
        const isHiddenLoose  = group => isHiddenStrict(group) && !(group.code && group.code.startsWith(data.name));

        // We try to use the strict predicate (matches exactly the name), if no element is found, use the loosed one (ARSWEB-467)
        const isHidden = this.groups.filter(group => !isHiddenStrict(group)).length === 0 ? isHiddenLoose : isHiddenStrict;

        // Expand / minify the group
        this.groups.map(group => group.$hideTable = isHidden(group));

        const displayedElement = this.groups.find(group => !isHidden(group));


        if (displayedElement && this.$location.hash() !== displayedElement.code) {
            this.$location.hash(displayedElement.code);
        } else {
            this.$anchorScroll();
        }
    }

    loadGroupData(tab) {
        this.tabName= tab;
        this.subGroups = DEF_GROUPS.filter(subGroup => subGroup.code !== tab);
        this.backendService.service.config.params[CONSOLIDATION_CURRENCY_PARAMS] = this.$scope.consolitationcurrency.code;
        this.format();

        if (this.$location.hash() !== "") {
            // ARSWEB-453: Click on the Graphics - Heat Map, Pie Chart or top 6 Balance by groupings should open up the respective List
            this.$scope.$broadcast('expandGroupData', { name : this.$location.hash() });
        }
    }
}
